import { print } from 'graphql';
import { BeneficiarioBaseAPI } from '@/api/beneficiario.base.api';
import { Beneficiario } from '@/models/beneficiario';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { map, catchError, tap } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import BeneficiarioStore from '@/store/modules/beneficiario';
import moment from 'moment';
import { Processo } from '@/models/processo';
import { Acampanhamento } from '@/models/acompanhamento';
import { router } from '@/router';
import BeneficiarioAuthService from '@/services/beneficiario.auth.service';
import { API_URL_SERVICE, VUE_APP_PDF_URL, VUE_APP_GRAPHQL_SPS_URL } from '@/commons/config';
import { Telefone } from '@/models/telefone';
import { Estado } from '@/models/estado';
import { Municipio } from '@/models/municipio';

const beneficiario = require('@/query/passe-livre/Beneficiario.graphql');
const processo = require('@/query/passe-livre/Processo.graphql');
const acompanhamento = require('@/query/passe-livre/Acompanhamentos.graphql');
const estado = require('@/query/Estado.graphql');
const municipio = require('@/query/Municipio.graphql');

export class BeneficiarioAPI extends BeneficiarioBaseAPI<Beneficiario> {
  apiUrlAcompanhamento: string = `${API_URL_SERVICE}/api/passe-livre/acompanhamento/`;
  protected graphqlUrlSPS: string = `${VUE_APP_GRAPHQL_SPS_URL}`;

  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api`;
  }

  public login(cpf: string, nascimento: string, recaptcha: string): AxiosObservable<any> {
    // const cpfBeneficiario = cpf.replace(/[^\d]+/g, '');
    // const dataNascimento = moment(nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD');

    return this.axios.get(
      `${this.apiUrl}/beneficiary/search?cpf=${cpf}&dataNascimento=${nascimento}`
    );
  }

  public findByCpfNascimento(cpf: number, dataNascimento: string): AxiosObservable<Beneficiario> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(beneficiario),
        variables: {
          cpf,
          dataNascimento,
        },
      })
      .pipe(
        map((data: any) => {
          const { beneficiario } = data;
          return beneficiario;
        })
      );
  }

  public create(beneficiario: Beneficiario): AxiosObservable<Beneficiario> {
    // beneficiario.cpf = beneficiario.cpf.replace(/[^\d]+/g, '');
    // beneficiario.dataNascimento = moment(beneficiario.dataNascimento).format('YYYY-MM-DD');
    // beneficiario.dataEmissaoDocumento = moment(beneficiario.dataEmissaoDocumento).format(
    //   'YYYY-MM-DD'
    // );
    // beneficiario.telefoneDdd = beneficiario.telefoneDdd.replace(/[^\d]+/g, '');
    // beneficiario.telefoneDdd2 = beneficiario.telefoneDdd2.replace(/[^\d]+/g, '');
    return this.axios.post(`${this.apiUrl}/beneficiary`, beneficiario).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  public update(idProcesso: number, beneficiario: Beneficiario): AxiosObservable<Beneficiario> {
    return this.axios
      .put(`${this.apiUrl}/beneficiary/${beneficiario.id}/process/${idProcesso}`, beneficiario)
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  public beneficiarioProcessos(beneficiarioId: number): AxiosObservable<Processo[]> {
    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(processo),
        variables: {
          id: beneficiarioId,
        },
      })
      .pipe(
        map((data: any) => {
          const { processos } = data;

          if (!processos) {
            return null;
          }

          return processos.map(
            (processo: any) =>
              new Processo(
                processo.id,
                processo.tipoProcesso,
                processo.tipoAtendimento,
                processo.acompanhamentos
              )
          );
        })
      );
  }

  public beneficiarioProcessoAcompanhamentos(
    beneficiarioId: number,
    processoId: number
  ): AxiosObservable<Acampanhamento> {
    return this.axios.get(`${this.apiUrl}/beneficiary/${beneficiarioId}/monitoring/${processoId}`);
  }

  public updateAcompanhamentoProcesso(
    beneficiarioId: number,
    processpId: number,
    situacaoId: number,
    recaptcha: string
  ): AxiosObservable<any> {
    return this.axios
      .post(`${this.apiUrl}/beneficiary/tracking/simple`, {
        beneficiarioId: beneficiarioId,
        processoId: processpId,
        situacaoId: situacaoId,
        recaptcha: recaptcha,
      })
      .pipe(map(response => response));
  }

  public updateAddress(
    beneficiarioId: number,
    cep: string,
    logradouro: string,
    numeroLogradouro: string,
    complemento: string,
    bairro: string,
    municipioIbge: number,
    telefoneDdd: string,
    telefoneNum: string,
    telefoneDdd2: string,
    telefoneNum2: string,
    email: string,
    recaptcha: string,
    telefones: Telefone[]
  ): AxiosObservable<Beneficiario> {
    telefoneDdd = telefoneDdd.replace(/[^\d]+/g, '');
    return this.axios.patch(`${this.apiUrl}/beneficiary/${beneficiarioId}/endereco`, {
      cep,
      logradouro,
      numeroLogradouro,
      complemento,
      bairro,
      municipioIbge,
      telefoneDdd,
      telefoneNum,
      telefoneDdd2,
      telefoneNum2,
      email,
      recaptcha,
      telefones,
    });
  }

  public generateReportPasseLivre(body: any): AxiosObservable<any> {
    return this.axios.post(
      `${VUE_APP_PDF_URL}/sps/passelivre/confirmacao/cadastro`,
      {
        ...body,
      },
      { responseType: 'blob' }
    );
  }

  public getAllEstados(): AxiosObservable<Estado[]> {
    return this.axios
      .post(`${this.graphqlUrlSPS}`, {
        query: print(estado),
        variables: {},
      })
      .pipe(
        map((data: any) => {
          const { estados } = data;

          return estados.map((estado: any) => new Estado(estado.id, estado.descricao));
        })
      );
  }

  public getAllMunicipios(): AxiosObservable<Municipio[]> {
    return this.axios
      .post(`${this.graphqlUrlSPS}`, {
        query: print(municipio),
        variables: {},
      })
      .pipe(
        map((data: any) => {
          const { municipios } = data;
          return municipios.map(
            (municipio: any) => new Municipio(municipio.id, municipio.descricao, municipio.ibge)
          );
        })
      );
  }

  public searchCep(cep: string): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/beneficiary/cep/${cep}`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        return throwError(error);
      })
    );
  }
}
